<template>
    <div v-if="resources">
        <b-card>
            <div slot="header">
                <b-button variant="success" @click="resourceModal = true"> {{ $t('createNew') }} </b-button>
            </div>
            <b-spinner v-if="!resources"/>
            <b-table hover :items="resources" :fields="fields" @row-clicked="goToResource" v-else></b-table>
            <span v-if="resources.length < 1"> {{ $t('noResources') }}. </span>
        </b-card>

        <b-modal v-model="resourceModal" title="New resource" @ok="createResource" ok-title="Create" ok-only>
             <b-form-group
                :label="this.$t('name')"
                label-for="name"
                :label-cols="2"
                :horizontal="true">
                    <b-form-input v-model="name"/>
            </b-form-group>
        </b-modal>

    </div>
</template>
<script>
export default {
    name: 'List',
    components: { },
    data: function() {
        return {
            resources: null,
            originalResources: null,
            fields: ["name"],
            name: '',
            resourceModal: false
        }
    },

    computed: {

    },
    methods: {
        createResource() {
            this.goToResource({name: this.name})
        },

        goToResource(item) {
            this.$router.push({path: "/admin/thunder/" + item.name});
        }
    },
    mounted() {
       this.$http.get("/v3/system/thunder").then(({data}) => {
            this.resources = data || []
       }).catch(err => {
           this.$debugLog(err)
           this.$bvModal.msgBoxOk(`${this.$t('failedToFetchResource')}.`)
       })
    }
}
</script>
